import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Utilizamos cookies',
    description:
      'Utilizamos cookies e tecnologias semelhantes para oferecer esta experiência. Os cookies estritamente necessários estão sempre ativos.',
    allow_label: 'Aceitar todos os cookies',
    reject_label: 'Apenas os estritamente necessários',
    settings_label: 'Definições de cookies',
    policy_link_label: 'Política de privacidade e cookies',
    categories_label: 'Categorias',
    always_on_label: 'Sempre ativos',
    required_label: 'Obrigatórios',
    save_preferences_label: 'Guardar preferências',
    close_label: 'Fechar',
    allow_all_optional_categories_label: 'Permitir todas as categorias opcionais',
    settings_title: 'Definições de cookies',
    settings_description:
      'Utilizamos cookies e tecnologias semelhantes para oferecer esta experiência. Os cookies estritamente necessários estão sempre ativos.',
    save_error: 'Não foi possível guardar a sua escolha de privacidade. Tente novamente.'
  },
  categories: {
    strictly_necessary: {
      name: 'Estritamente necessários',
      purpose: 'Necessários para disponibilizar esta experiência e não podem ser desativados.'
    },
    analytics: {
      name: 'Análise',
      purpose: 'Mede como os visitantes usam esta experiência para melhorar o desempenho.'
    },
    marketing: { name: 'Marketing', purpose: 'Apoia publicidade e marketing escolhidos pelo organizador.' }
  }
};

export default locale;
